var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingMail1 = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4654 11.2492V4.82059C14.4654 4.82059 7.9654 9.35631 7.33326 9.59166C6.71183 9.36702 0.179688 4.82059 0.179688 4.82059V11.2492C0.179688 12.142 0.368973 12.3206 1.25112 12.3206H13.394C14.2972 12.3206 14.4654 12.1638 14.4654 11.2492ZM14.455 3.56023C14.455 2.90988 14.2654 2.67773 13.394 2.67773H1.25112C0.354687 2.67773 0.179688 2.95631 0.179688 3.60631L0.190402 3.70631C0.190402 3.70631 6.64362 8.14916 7.33326 8.39202C8.06183 8.10988 14.4654 3.60631 14.4654 3.60631L14.455 3.56023Z",
    fill: "#7E8899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.455 3.56023C14.455 2.90988 14.2654 2.67773 13.394 2.67773H1.25112C0.354687 2.67773 0.179688 2.95631 0.179688 3.60631L0.190402 3.70631C0.190402 3.70631 6.64362 8.14916 7.33326 8.39202C8.06183 8.10988 14.4654 3.60631 14.4654 3.60631L14.455 3.56023Z",
    fill: "#7E8899"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingMail1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/settingMail1.90a3d9b5640dd357145a4ad24156d708.svg";